import { LinkButton, Switch, useDeviceType } from '@cian/ui-kit';
import { useLinkButtonProps } from 'shared/hooks';
import * as styles from './styles.css';
import { useToggleState } from '@cian/react-utils';
import { AdvertBlock } from './components/AdvertBlock';
import { MapBlock } from './components/MapBlock';
import { LK_MY_OFFERS_LINK } from 'shared/constants/links';
import { clsx } from 'clsx';

export const MoreViewsBanner: React.FC = () => {
  const { state: moreViews, toggle: toggleMoreViews } = useToggleState(false);
  const linkButtonProps = useLinkButtonProps();
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['text-block']}>
        <div className={styles['first-text-block']}>
          <div className={styles['list-title']}>Установите ставку выше 80% конкурентов</div>
          <ul className={styles['list']}>
            <li className={styles['list-item']}>Выделим ваше объявление на карте</li>
            <li className={styles['list-item']}>Покажем 4 фото в поиске</li>
            <li className={styles['list-item']}>Отобразим заголовок</li>
          </ul>
        </div>
        <div className={styles['second-text-block']}>
          <div className={styles['toggle-title']}>Это поможет получить еще больше просмотров</div>
          <div className={styles['toggle-block']}>
            <Switch onChange={toggleMoreViews} checked={moreViews} label="Обойти конкурентов" />
          </div>
        </div>
      </div>
      <div className={styles['results-block']}>
        <AdvertBlock isExpanded={moreViews} device={device} />
        <MapBlock showPromoPins={moreViews} device={device} />
      </div>
      <div className={styles['btn-block']}>
        <LinkButton {...linkButtonProps} href={LK_MY_OFFERS_LINK}>
          Обойти конкурентов
        </LinkButton>
      </div>
    </div>
  );
};
